import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export function parseDate(dateInput: any): any {
    if (!dateInput) return dateInput;
    if (Array.isArray(dateInput)) {
        if (dateInput.length >= 6) {
            return new Date(Date.UTC(dateInput[0], dateInput[1] - 1, dateInput[2], dateInput[3], dateInput[4], dateInput[5])).toISOString();
        } else if (dateInput.length >= 3) {
            return new Date(Date.UTC(dateInput[0], dateInput[1] - 1, dateInput[2])).toISOString();
        }
    }
    if (typeof dateInput === 'string') {
        const cleaned = dateInput.replace(/\[.*\]$/, ''); // Remove [UTC] suffix
        const parsed = new Date(cleaned);
        if (!isNaN(parsed.getTime())) {
            return parsed.toISOString();
        }
    }
    return dateInput;
}

@Injectable({ providedIn: 'root' })
export class ChatService {
    constructor(private _httpClient: HttpClient) { }

    list(body: {
        q?: string;
        type?: string;
        page?: number;
        size?: number;
        sort?: string;
        direction?: string;
    }): Observable<any> {
        return this._httpClient.post('admin/conversation/list', body).pipe(
            map((res: any) => {
                if (res && res.list) {
                    res.list.forEach((conv: any) => {
                        if (conv.lastMessage && conv.lastMessage.createdAt) {
                            conv.lastMessage.createdAt = parseDate(conv.lastMessage.createdAt);
                        }
                    });
                }
                return res;
            })
        );
    }

    sendMessage(conversationId: string, content: FormData): Observable<any> {
        return this._httpClient.post('admin/conversation/' + conversationId + '/message', content).pipe(
            map((res: any) => {
                if (res && res.createdAt) res.createdAt = parseDate(res.createdAt);
                return res;
            })
        );
    }

    readMessage(conversationId: string, messageId: string): Observable<any> {
        return this._httpClient.get('admin/conversation/read/' + conversationId + '/' + messageId);
    }

    getConversation(conversationId: string): Observable<any> {
        return this._httpClient.get('admin/conversation/' + conversationId).pipe(
            map((res: any) => {
                if (res && res.messages) {
                    res.messages.forEach((m: any) => {
                        if (m.createdAt) m.createdAt = parseDate(m.createdAt);
                    });
                }
                return res;
            })
        );
    }

    closeConversation(conversationId: string): Observable<any> {
        return this._httpClient.post('admin/conversation/' + conversationId + '/close', {});
    }

    getMetrics(): Observable<any> {
        return this._httpClient.get('admin/conversation/metrics');
    }
}
